export default __webpack_public_path__ + "static/media/bin.f0ca2410.svg";